import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import {IndividuService} from '@Common/core/services';

import { map } from 'rxjs/operators';
import {rolesDar} from '../services/roles/roles-dar';
import {of} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ForbiddenGuard  {
  constructor(private individuService: IndividuService,
              private router: Router) {
  }

  canLoad(route: Route): Observable<boolean> {
    return of(true);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.isGestionnaire().pipe(map(r => {
      if (r) {
        this.router.navigate(['/']);
        return false;
      } else {
        return true;
      }
    }));
  }

  private isGestionnaire(): Observable<boolean> {
    return new Observable(observer => {
      this.individuService.individu$.subscribe(_individu => {
        if (this.powerfull(_individu) || this.isGestionnaire()) {
          observer.next(true);
          observer.complete();
        } else {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  private powerfull(individu) {
    if (this.individuService.hasRole(individu, rolesDar.admin)) {
      return true;
    }

    if (this.individuService.hasRole(individu, rolesDar.gestionnaire)) {
      return true;
    }
  }
}

